import { Location } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { IGlobalNavigationComponent } from 'shared.models/global-navigation.interface';

@Component({
  selector: '[nc-global-navigation]',
  templateUrl: './global-navigation.component.html',
  standalone: false,
})
export class GlobalNavigationComponent implements IGlobalNavigationComponent {
  @Input() isBackEnabled: boolean;
  @Input() isHomeEnabled: boolean;
  @Input() overrideBackNavigation: boolean;
  @Input() overrideHomeNavigation: boolean;
  @Output() homeButtonClicked = new EventEmitter<Element>();
  @Output() backButtonClicked = new EventEmitter<Element>();

  constructor(private location: Location,
    private router: Router,
  ) { }

  onBackButtonClicked(event: Event): void {
    event.preventDefault();
    if (!this.overrideBackNavigation) {
      this.location.back();
    }
    this.backButtonClicked.emit(event.target as HTMLElement);
  }

  onHomeButtonClicked(event: Event): void {
    event.preventDefault();
    if (!this.overrideHomeNavigation) {
      this.router.navigate(['/dispense']);
    }
    this.homeButtonClicked.emit(event.target as HTMLElement);
  }
}
